module.exports = __webpack_public_path__ + "static/grapes-af9e094e2980223f9195e9104ffd14fc.jpg";